import React, { useEffect, useState } from 'react'
import { Platform } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { B2, BTN_LG, SH1, SH3, Stack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'

import useFilterStore from '../../hooks/useFilterStore'
import CardStack from './../../assets/svg/cardStack.svg'

const isWeb = Platform.OS === 'web'

const NoOfferV2 = ({
  categoryName,
  categoryId,
  customerId,
  onClearFilter,
  isBMSFlow,
  isJfsFlow = false
}: {
  categoryName: string
  categoryId?: string | number
  customerId?: string | number
  onClearFilter?: () => void
  isBMSFlow: boolean
  isJfsFlow?: boolean
}) => {
  const [isVisibleClearAll, setIsVisibleClearAll] = useState(false)

  const { subFilters, sort, quickFilter } = useFilterStore((state) => ({
    quickFilter: state?.quickFilter,
    sort: state?.sort,
    subFilters: state?.subFilters,
  }))

  // To figure out if a filter is active
  useEffect(() => {
    const subFilterKeys = Object.keys(subFilters)

    if (quickFilter?.length > 0 || Number(sort?.length) > 0) {
      setIsVisibleClearAll(true)
    } else if (subFilterKeys?.length > 0) {
      for (let index = 0; index < subFilterKeys?.length; index++) {
        if (subFilters?.[subFilterKeys?.[index]]?.length > 0) {
          setIsVisibleClearAll(true)
          break
        }
      }
    } else {
      setIsVisibleClearAll(false)
    }
  }, [sort?.length, quickFilter?.length, subFilters])

  useEffect(() => {
    if (categoryId) {
      publishEvent('screen_view', {
        screen_name: `no_products_for ${
          isWeb
            ? 'filter_recommendation_web'
            : customerId
            ? 'filter_recommendation_app'
            : 'filter_brand_list'
        }`,
        product: categoryId,
      })
    }
  }, [categoryId, customerId])

  return (
    <Stack
      className="items-center justify-center py-3"
      style={{
        height: !isWeb ? DEVICE_HEIGHT * 0.3 : DEVICE_HEIGHT * 0.65,
      }}
    >
      <CardStack />

      {isBMSFlow ? (
        <>
          <SH1 className="my-2">
            {i18n.t('recommendationState.ineligible.sorry')}
          </SH1>
          <B2> {i18n.t('recommendationState.ineligible.message')}</B2>
        </>
      ) : (
        <SH3 className="text-grays-70 mt-2 ">
          {i18n.t('recommendationState.empty.noOffer')}
        </SH3>
      )}
      {isVisibleClearAll && (
        <Pressable
          className="bg-primary-10 py-4/2 mt-4 rounded-lg px-4"
          onPress={onClearFilter}
        >
          <BTN_LG className={`${isJfsFlow ? 'text-[#000]' : 'text-primary-100'}`}>
            {i18n.t('recommendationState.empty.clearFilters')}
          </BTN_LG>
        </Pressable>
      )}
    </Stack>
  )
}

export default NoOfferV2
